// extracted by mini-css-extract-plugin
export default {"container":"createUser_container__Hpr1Z","tabLabel":"createUser_tabLabel__kJMCx","pageHeader":"createUser_pageHeader__rMBlw","headerUser":"createUser_headerUser__JeyWF"};